module.exports = __webpack_public_path__ + "static/media/icon_nav_partner.02eff8aa.svg";